function PageNotFound(props) {
  window.location.replace(process.env.REACT_APP_URL_WEBSITE);
  return null;
}

export default PageNotFound;